<span [ngSwitch]="entryToDisplay.field_type">
  <a *ngSwitchCase="'id'" [href]="url" target="_blank">
    {{ data }}
    <mat-icon>launch</mat-icon>
  </a>
  <span *ngSwitchCase="'address'">
    <ng-container *ngIf="data">
      <span>{{ data['street'] }}</span>
      <span>{{ data['postalCode'] }}</span>
      <span>{{ data['city'] }}</span>
      <span>{{ data['country'] }}</span>
    </ng-container>
  </span>
  <span *ngSwitchCase="'date'">
    <!-- date without time, entered by user, do not use pipe dateTimezone -->
    {{ data | date: 'shortDate' }}
  </span>
  <span *ngSwitchCase="'datetime'">
    {{ data | dateTimezone: 'short' }}
  </span>
  <span *ngSwitchDefault>{{ data }}</span>
</span>
